import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { ICONS } from './Icon';
import { IconButton } from './IconButton';

type Props = {
  selectionState: 'none' | 'all' | 'some';
  onSelectAll: () => void;
  onSelectNone: () => void;
  style?: StyleProp<ViewStyle>;
};

export const ListSelectAllCheckbox: React.FC<Props> = ({
  selectionState,
  onSelectAll,
  onSelectNone,
  style,
}) => {
  return (
    <IconButton
      icon={
        selectionState === 'some'
          ? ICONS.SquareMinusLight
          : selectionState === 'all'
            ? ICONS.SquareCheckSolid
            : ICONS.SquareLight
      }
      iconSize={19}
      onPress={selectionState === 'none' ? onSelectAll : onSelectNone}
      accessibilityHint={
        selectionState === 'none'
          ? 'Selects all items in list'
          : 'Deselects all items in list'
      }
      style={style}
    />
  );
};
